import React from 'react'
import PropTypes from 'prop-types'
import Card from '../ui/Card'

const TableFrame = ({ children, framed, headerRight, title }) => {
  if (!framed)
    return <div className="tw:flex tw:flex-col tw:gap-4">{children}</div>
  return <Card headerRight={headerRight} title={title} plainHeader>{children}</Card>
}

TableFrame.propTypes = {
  children: PropTypes.node.isRequired,
  framed: PropTypes.bool,
  headerRight: PropTypes.node,
  title: PropTypes.string.isRequired
}

TableFrame.defaultProps = {
  framed: true,
  headerRight: null
}

export default TableFrame
